import config from "../config";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const uploadImageToS3 = async ({ originalFiles, folderName, bucketName }) => {
  const files = await Promise.all(
    Array.from(originalFiles).map(async (file) => {
      const base64 = await getBase64(file);
      return {
        base64,
        type: file.type,
      };
    })
  );
  console.log("files22", files);
  try {
    const res = await fetch(`${config.uploadTOS3}/uploadToS3`, {
      method: "POST",
      body: JSON.stringify({
        files,
        folder: folderName,
        bucketName,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  } catch (err) {
    console.log(err);
  }
};

export default uploadImageToS3;
